import { useContext } from "react";
import { AccountContext } from "contexts/AccountContext";

// ==============================|| CONFIG - HOOKS  ||============================== //

const useAccounts = () => useContext(AccountContext);

export default useAccounts;
